/**
 * コモンクラス
 * @constructor
 */
class Common {
  constructor() {

  }
  /**
   * コモン
   */
  init() {
    $('.modalOpen').on('click',(e)=>{
      this.modalOpen(e.currentTarget);
    })
    $('.modal__close,.modal__lay').on('click',()=>{
      this.modalClose();
    })

    $('.modalOpen02').on('click',function(e){
      $('.modal02').fadeIn(200);
    })
    $('.modal02__close,.modal02__lay').on('click',function(e){
      $('.modal02').fadeOut(200);
    })
    
    if("#alpahCharge" == location.hash) {
      $(".p-qa__tabItem").removeClass('active');
      $(".p-qa__tabItem--02").addClass('active');
      $(".p-qa__tabContent").removeClass('show');
      $(".p-qa__tabContent--02").addClass('show');
    }
    
    $('.js-active').on('click', function () {
      $(this).next().stop().slideToggle();
      $(this).toggleClass('active');
    })

    $(".video-cm").modaal({ type: 'video' });
    
  }
    
  modalOpen(el){
    let data = $(el).data('type');
    $('.modaTable').removeClass('is-active');
    $('#table-'+data).addClass('is-active');
    $('.modal').fadeIn(200);
  }
  modalClose(){
    $('.modal').fadeOut(200,()=>{
      $('.modaTable').removeClass('is-active');
    });
  }
}

export default Common;
